import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

const initialState = {
  newPatientId: null,
  firstName: null,
  lastName: null,
  patientUpdated: false,
  isAdvanceSearch: false,
};

export const PatientSlice = createSlice({
  name: "patientDetails",
  initialState,
  reducers: {
    patientName: (state, action: PayloadAction<any>) => {
      state.newPatientId = action.payload.newPatientId;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
    },
    updatedPatient: (state, action: PayloadAction<any>) => {
      state.patientUpdated = action.payload;
    },

    /** This function has to state that to handle the pagination query on advance search like boolean method */
    updateSearchStatus: (state, action: PayloadAction<any>) => {
      state.isAdvanceSearch = action.payload;
    },
  },
});

export const { patientName, updatedPatient, updateSearchStatus } = PatientSlice.actions;
export const patientDetailsState = (state: RootState) => state.patientDetails;
export default PatientSlice.reducer;
